<template>
  <div class="text-center">
    <v-dialog v-model="dialog" @keydown.esc="cancel" persistent width="500">
      <v-card>
        <v-card-title>Add Data Item</v-card-title>
        <div class="px-4 pt-4">
          <v-form v-model="isFormValid" ref="form" lazy-validation>
            <div>
              <v-select
                v-model="level"
                :items="levelsList"
                :disabled="levelId === 0"
                label="Level"
                outlined
                dense
              ></v-select>
            </div>
            <div>
              <v-select
                v-model="selectedForm"
                :items="formList"
                label="Form name"
                outlined
                dense
              ></v-select>
            </div>
            <div>
              <v-select
                v-model="selectedInput"
                :items="inputList"
                item-text="Description"
                item-value="ShortName"
                label="Input title"
                outlined
                dense
              ></v-select>
            </div>
          </v-form>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="cancel"> Cancel </v-btn>
          <v-btn color="primary" depressed @click.native="ok"> Ok </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'DataItem',
  props: { levelId: { type: Number, required: true } },

  data() {
    return {
      loadign: false,
      dialog: false,

      level: this.levelId,
      selectedForm: null,
      formList: [],
      selectedInput: null,
      inputList: [],

      isFormValid: false,
      rules: [(v) => !!v || 'Required.'],
    };
  },

  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },

    levelsList() {
      return [
        { text: 'System', value: 0 },
        { text: 'Plan', value: this.currentPlanId },
      ];
    },

    selectedDataItem() {
      return `[${this.selectedForm}.${this.selectedInput}]`;
    },
  },

  watch: {
    selectedForm() {
      if (this.level !== null && this.selectedForm) this.getFormElements();
    },
  },

  mounted() {
    this.getFormList();
  },

  methods: {
    open() {
      this.dialog = true;
    },

    ok() {
      this.$emit('addDataItem', this.selectedDataItem);
      this.resetInfo();
      this.dialog = false;
    },

    cancel() {
      this.resetInfo();
      this.dialog = false;
    },

    resetInfo() {
      this.level = null;
      this.selectedForm = null;
      this.selectedInput = null;
    },

    async getFormList() {
      this.loading = true;

      try {
        let response = await this.$api.get('/DataDictionary/GetFormList');

        if (!response.data.length) {
          const msg = 'Unable to load forms';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        var data = response.data;
        this.formList = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async getFormElements() {
      this.loading = true;

      try {
        let response = await this.$api.get(
          `/DataDictionary/GetFieldList?planId=${this.level}&formName=${this.selectedForm}`
        );
        var data = response.data;
        this.inputList = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
